<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Referans Model</label>
            <v-select-list multiple :options="c_referenceModels" label="VehicleReferenceModelManuelName" v-model="referenceModel" placeholder="Referans Model"></v-select-list>
        </div>
        <div class="col-md-6 mb-1">
            <label class="form-label">Başlangıç İli</label>
            <v-select-list v-model="startProvince" :options="provinces" label="Name" v-on:input="getDistricts(true)" placeholder="Başlangıç İli"></v-select-list>
        </div>
        <div class="col-md-6 mb-1">
            <label class="form-label">Başlangıç İlçesi</label>
            <v-select-list :disabled="!startProvince" v-model="startDistrict" :options="districts" label="Name" placeholder="Başlangıç İlçesi"></v-select-list>
        </div>
        <div class="col-md-12 mb-1">
            <b-form-checkbox v-model="isAvoidTolls" inline>Paralı Yolları Dahil Et</b-form-checkbox>
            <b-form-checkbox v-model="isAvoidHighways" inline>Anayolları Dahil Et</b-form-checkbox>
        </div>
        <div class="col-12 mb-1">
            <b-form-radio v-model="type" inline v-for="(t,i) in types" :key="i" :value="t.value">
                <div class="d-flex align-items-center">
                    <strong>{{t.from}}</strong>
                    <feather-icon icon="ChevronRightIcon" class="text-muted"></feather-icon>
                    <strong>{{t.to}}</strong>
                </div>
            </b-form-radio>
        </div>
        <div class="col-12 mb-1" v-if="type == 2">
            <div class="alert alert-dark mb-0">
                <div class="alert-body p-75">
                    <div class="mb-50 d-flex justify-content-between align-items-center">
                        <div>
                            Toplam {{selectedProvinces.length}} Adet
                        </div>
                        <div>
                            <button class="btn btn-sm btn-danger" v-on:click="selectedProvinces = []">Temizle</button>
                        </div>
                    </div>
                    <v-select-list :close-on-select="false" :options="c_selectableProvinces" label="Name" v-model="selectedProvinces" placeholder="İl Seçiniz" multiple></v-select-list>
                </div>
            </div>
        </div>
        <div class="col-12">
            <v-executer :disabled="c_disabledCalculate" full-width variant="success" :loading="calculating" :text="calculating ? `Hesaplanıyor... Bu işlem uzun sürebilir.` :'Hesapla ve Ekle'" :action="appendRoutes"></v-executer>
        </div>
    </div>
</template>

<script>
import { BFormRadio,BFormCheckbox } from 'bootstrap-vue'
import CalculatePriceApi from '@/api/calculate-price'
import SystemDataApi from '@/api/system-data'
import randomatic from 'randomatic'

export default {
    components:{
        BFormRadio,
        BFormCheckbox
    },
    props:{
        value:Object,
        oneDayKm:Number,
    },
    mounted(){
        this.getProvince()
        this.getReferenceModels()
    },
    watch:{
        startProvince(){
            this.startDistrict = null
            this.startNeighbourhood = null
        },
    },
    data(){
        return{
            types:[
                { from:"Başlangıç: Seçili İlçe",to:"Bitiş: Tüm İlçeler",value:0 },
                { from:"Başlangıç: Seçili İlçe",to:"Bitiş: Tüm İl Merkezleri",value:1 },
                { from:"Başlangıç: Seçili İlçe",to:"Bitiş: Seçil İl Merkezleri",value:2 },
            ],
            type:0,
            isAvoidTolls:false,
            isAvoidHighways:false,
            calculating:false,
            referenceModels: [],
            referenceModel: [],
            provinces:[],
            districts:[],
            startProvince:null,
            startDistrict:null,
            selectedProvinces:[],
            calculationCounts:{
                maxLength:0,
                index:0
            }
        }
    },
    methods:{
        clearForm(){
            this.startProvince = null
            this.startDistrict = null
            this.referenceModel = []
            this.isAvoidTolls = false
            this.isAvoidHighways = false
        },
        getReferenceModels(){
            CalculatePriceApi.ReferenceModel.List()
            .then(res=>{
                this.referenceModels = res.data.Data
            })
        },
        getProvince(){
            SystemDataApi.ProvinceByCountry('43776974-AB91-4FA2-B2AC-87B5E8939241')
            .then((res) => {
                this.provinces = res.data.Data
                this.selectedProvinces = this.c_selectableProvinces
            })
        },
        getDistricts(){
            if(this.startProvince?.Id){
                SystemDataApi.District(this.startProvince.Id)
                .then((res) => {
                    this.districts = res.data.Data
                })
            }
        },
        calculateDistance(){
            return new Promise((resolve,reject)=>{
                if(this.startDistrict?.Id){
                    debugger;
                    if(this.type == 0){
                        CalculatePriceApi.DraftPrice.OtherDistrict(this.startDistrict.Id,this.isAvoidTolls,this.isAvoidHighways).then(res=>{
                            resolve(res)
                        }).catch(err=>reject())
                    }else if(this.type == 1){
                        CalculatePriceApi.DraftPrice.CenterDistrict(this.startDistrict.Id,this.isAvoidTolls,this.isAvoidHighways).then(res=>{
                            resolve(res)
                        }).catch(err=>reject())
                    }else if(this.type == 2){
                        CalculatePriceApi.DraftPrice.SelectedProvinceCalculate({
                            ProvinceIds: this.selectedProvinces.map(p=>p.Id),
                            StartDistrictId:this.startDistrict.Id,
                            Tolls:this.isAvoidTolls,
                            Highways:this.isAvoidHighways
                        }).then(res=>resolve(res)).catch(err=>reject())
                    }
                }else reject()
            })
        },
        appendRoutes(){
            this.calculating = true
            this.calculateDistance().then(res=>{
                if(res.data.Success){
                    this.referenceModel.forEach((rm)=>{
                        res.data.Data.forEach(d=>{
                            let route = this.uncalculatedData(d,'Manual',rm,1,this.oneDayKm)
                            this.value.UncalculatedRoutes.push(route)
                        })
                    })
                    this.clearForm()
                    this.calculating = false
                }
            }).catch(err=>{
                this.calculating = false
            })
        },
        uncalculatedData(data,type,rm,countOfTrips,oneDayKm){
            return {
                id:randomatic("A0",10),
                selected:false,
                startProvince: data.StartProvinceId ? { Id:data.StartProvinceId, Name:data.StartProvinceName } : null,
                startDistrict: data.StartDistrictId ? { Id:data.StartDistrictId, Name:data.StartDistrictName } : null,
                startNeighborhood: data.StartNeighborhoodId ? { Id:data.StartNeighborhoodId, Name:data.StartNeighborhoodName } : null,
                endProvince: data.EndProvinceId ? { Id:data.EndProvinceId, Name:data.EndProvinceName } : null,
                endDistrict: data.EndDistrictId ? { Id:data.EndDistrictId, Name:data.EndDistrictName } : null,
                endNeighborhood: data.EndNeighborhoodId ? { Id:data.EndNeighborhoodId, Name:data.EndNeighborhoodName } : null,
                customerKm:0,
                isAvoidTolls:data.Tolls,
                isAvoidHighways:data.Highways,
                referenceModel:rm,
                countOfTrips:countOfTrips,
                countOfDaysWorked:Math.ceil(data.Distance/oneDayKm),
                type:type,
                calculatedDistance: data.Distance
            }
        },
    },
    computed:{
        c_disabledCalculate(){
            if(this.referenceModel.length > 0 
                && this.startProvince 
                && this.startDistrict) return false
            else return true
        },
        c_selectableProvinces(){
            this.selectedProvinces = this.selectedProvinces.filter(p=> p.Id != this.startProvince?.Id)
            return this.provinces.filter(p=> p.Id != this.startProvince?.Id)
        },
        c_referenceModels(){
            if(this.referenceModel.length > 0){
                const first = this.referenceModel[0]
                return this.referenceModels.filter(rm => rm.GroupNumber == first.GroupNumber)
            }else return this.referenceModels
        }
    }
}
</script>

<style>

</style>